import { API } from '../../../api';
import { axiosInstance } from '../../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

let getTenderListEffectCancelToken = () => {};

export const getTenderListEffect = (data) => {
  getTenderListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetBindTenderList`,
    method: 'get',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getTenderListEffectCancelToken = c;
    }),
  });
};

let getTenderNameEffectCancelToken = () => {};
export const getTenderNameEffect = (data) => {
  getTenderNameEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetTendersByProject`,
    method: 'get',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getTenderNameEffectCancelToken = c;
    }),
  });
};

let getTenderCopyEffectCancelToken = () => {};
export const getTenderCopyEffect = (params) => {
  getTenderCopyEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetEditOrCopyTender`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getTenderCopyEffectCancelToken = c;
    }),
  });
};

let updateTenderEffectCancelToken = () => {};
export const updateTenderEffect = (data) => {
  updateTenderEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/PostUpdateTender`,
    method: 'post',
    data,
    cancelToken: new CancelToken(function executor(c) {
      updateTenderEffectCancelToken = c;
    }),
  });
};

export const getBidParameterEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetSearch`,
    method: 'get',
    params: data,
  });
};

export const getTransportationModeEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetTransportationMode`,
    method: 'get',
    params: data,
  });
};

export const getTenderModeEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetTenderMode`,
    method: 'get',
    params: data,
  });
};

export const getLaneInformationEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/PostTaggedTenderLanes`,
    method: 'GET',
    params: data,
  });
};
export const getAddLaneInformationEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetLaneBy`,
    method: 'GET',
    params: data,
  });
};

export const getTransportProviderEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetBindTaggedTenderCarriers`,
    method: 'get',
    params: data,
  });
};

export const getHistoricalBidListEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetHistoricalBid`,
    method: 'get',
    params: data,
  });
};

export const deleteProcurementTenderLaneEffects = (params) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/DeleteTenderLanes`,
    method: 'delete',
    data: params,
  });
};

export const postActionToTenderCarriersEffects = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/PostActionToTenderCarriers`,
    method: 'post',
    data,
  });
};
